export const getProfileWorkBeforeUrl = `/portal-person-info/profile/work/before`;

export const updateProfileWorkBeforeUrl = (screenCode: string) =>
  `/portal-person-info/profile/work/before/${screenCode}`;

export const getProfileWorkUrl = `/portal-person-info/profile/work`;

export const geLaborContractUrl = `/portal-person-info/profile/labor-contract`;

export const getFileLaborContractUrl = (laborContractId: string) =>
  `/portal-person-info/file/${laborContractId}/LABOR_CONTRACT`;
